import { useSuspenseQuery } from '@tanstack/react-query'

import { GetPlantaDoLoteamentoService } from '@/features/empreendimentos/services/get-planta-do-loteamento.service'
import { empreendimentosKeys } from '@/features/empreendimentos/utils'

export const useSuspensePlantaDoLoteamento = (idExterno: string) => {
  return useSuspenseQuery({
    queryKey: empreendimentosKeys.plantaDoLoteamento(idExterno),
    queryFn: async () => new GetPlantaDoLoteamentoService().execute(idExterno).then((res) => res.data),
  })
}
